import type { ReactNode } from 'react'

import { cx } from '@/Ship/Helpers/cssClass'

import styles from './FormSection.module.css'

interface FormRowProps {
    className?: string
    children: ReactNode
}

/** Кілька полів в один ряд рівними колонками; на телефоні — стовпчиком */
export const FormRow = ({ className, children }: FormRowProps) => (
    <div className={`${cx(styles, 'row')} ${className ?? ''}`}>{children}</div>
)
